import type { Product } from "@/types/content";

export const products: Product[] = [
  {
    id: "protector-solar-spf-50",
    name: "Protector Solar SPF 50",
    category: "Proteccion solar",
    image: "/images/products/protector-solar-spf-50.jpg",
    thumbnailImage: "/images/products/thumbs/protector-solar-spf-50.jpg",
    statusLabel: "Proximamente",
    benefit: "Proteccion diaria de amplio espectro UVA + UVB.",
    description:
      "Crema ultraligera para uso diario con SPF 50, pensada para proteger, prevenir y cuidar la piel sin sensacion pesada. Ideal para todo tipo de piel como ultimo paso de la rutina.",
  },
  {
    id: "suero-acido-hialuronico",
    name: "Suero Acido Hialuronico",
    category: "Sueros",
    image: "/images/products/suero-acido-hialuronico.jpg",
    thumbnailImage: "/images/products/thumbs/suero-acido-hialuronico.jpg",
    statusLabel: "Proximamente",
    benefit: "Hidratacion profunda para piel mas elastica y jugosa.",
    description:
      "Serum hidratante formulado para ayudar a rellenar visualmente la piel, mejorar elasticidad y aportar una apariencia fresca. Una pieza clave para rutinas enfocadas en hidratacion.",
  },
  {
    id: "crema-hidratante-intensiva",
    name: "Crema Hidratante Intensiva",
    category: "Hidratacion",
    image: "/images/products/crema-hidratante-intensiva.jpg",
    thumbnailImage: "/images/products/thumbs/crema-hidratante-intensiva.jpg",
    statusLabel: "Proximamente",
    benefit: "Repara, nutre y protege la barrera cutanea.",
    description:
      "Crema de textura confortable para fortalecer la barrera de la piel, brindar nutricion y ayudar a conservar hidratacion. Pensada para pieles que buscan suavidad y confort duradero.",
  },
  {
    id: "suero-niacinamida",
    name: "Suero de Niacinamida",
    category: "Sueros",
    image: "/images/products/suero-niacinamida.jpg",
    thumbnailImage: "/images/products/thumbs/suero-niacinamida.jpg",
    statusLabel: "Proximamente",
    benefit: "Luminosidad, equilibrio y textura mas refinada.",
    description:
      "Serum con niacinamida enfocado en mejorar visiblemente la textura, minimizar apariencia de poros y unificar el tono. Ideal para rutinas que buscan equilibrio y luminosidad.",
  },
  {
    id: "gel-limpiador-facial",
    name: "Gel Limpiador Facial Purificante",
    category: "Limpieza",
    image: "/images/products/gel-limpiador-facial.jpg",
    thumbnailImage: "/images/products/thumbs/gel-limpiador-facial.jpg",
    statusLabel: "Proximamente",
    benefit: "Limpia, equilibra y refresca sin agredir la piel.",
    description:
      "Gel limpiador facial para uso diario, creado para retirar impurezas y dejar una sensacion fresca. Apto para todo tipo de piel, incluida piel sensible.",
  },
  {
    id: "exfoliante-enzimatico",
    name: "Exfoliante Enzimatico",
    category: "Renovacion",
    image: "/images/products/exfoliante-enzimatico.jpg",
    thumbnailImage: "/images/products/thumbs/exfoliante-enzimatico.jpg",
    statusLabel: "Proximamente",
    benefit: "Renueva, suaviza e ilumina con exfoliacion suave.",
    description:
      "Exfoliante suave de enfoque enzimatico para ayudar a retirar celulas muertas e impurezas sin irritar. Ideal para mejorar textura y luminosidad.",
  },
  {
    id: "contorno-de-ojos",
    name: "Contorno de Ojos Advanced Treatment",
    category: "Ojos",
    image: "/images/products/contorno-de-ojos.jpg",
    thumbnailImage: "/images/products/thumbs/contorno-de-ojos.jpg",
    statusLabel: "Proximamente",
    benefit: "Desinflama, ilumina y reafirma la zona del contorno.",
    description:
      "Tratamiento intensivo para el contorno de ojos, pensado para ayudar a reducir apariencia de ojeras, bolsas y lineas de expresion mientras aporta luminosidad.",
  },
  {
    id: "mascara-calmante-reparadora",
    name: "Mascara Calmante y Reparadora",
    category: "Mascarillas",
    image: "/images/products/mascara-calmante-reparadora.jpg",
    thumbnailImage: "/images/products/thumbs/mascara-calmante-reparadora.jpg",
    statusLabel: "Proximamente",
    benefit: "Calma, hidrata y restaura la barrera cutanea.",
    description:
      "Mascara de apoyo para piel sensibilizada o deshidratada. Ayuda a calmar irritaciones, reforzar la barrera y recuperar confort en la piel.",
  },
  {
    id: "kit-recovery-system",
    name: "Recovery System Kit",
    category: "Kits",
    image: "/images/products/kit-recovery-system.jpg",
    thumbnailImage: "/images/products/thumbs/kit-recovery-system.jpg",
    statusLabel: "Proximamente",
    benefit: "Kit post-tratamiento para calmar, reparar y proteger.",
    description:
      "Sistema de recuperacion post-tratamiento con enfoque calmante y reparador. Incluye productos pensados para acompanar la piel despues de procedimientos esteticos.",
  },
  {
    id: "kit-glow-inicial",
    name: "Starter Glow Kit",
    category: "Kits",
    image: "/images/products/kit-glow-inicial.jpg",
    thumbnailImage: "/images/products/thumbs/kit-glow-inicial.jpg",
    statusLabel: "Proximamente",
    benefit: "Rutina esencial para una piel radiante.",
    description:
      "Kit inicial con pasos esenciales para limpiar, hidratar y proteger. Pensado para quienes quieren empezar una rutina ALÉA enfocada en luminosidad y cuidado diario.",
  },
  {
    id: "kit-hidratacion-profunda",
    name: "Deep Hydration Kit",
    category: "Kits",
    image: "/images/products/kit-hidratacion-profunda.jpg",
    thumbnailImage: "/images/products/thumbs/kit-hidratacion-profunda.jpg",
    statusLabel: "Proximamente",
    benefit: "Rutina esencial para una piel hidratada.",
    description:
      "Kit de hidratacion profunda con productos orientados a equilibrar, reparar y conservar la humedad de la piel. Ideal para rutinas de confort y recuperacion de luminosidad.",
  },
];


